import React from 'react';

import Root from 'containers/Root';

const App = (props) => <Root store={ props.store } history={ props.history } />

export default App;
